import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { exportTrackingLinkEntryPoints, fetchTrackingEntryPoints } from '@/services/ab-testing';
import { ABComparisonView } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/ab-comparison-view';
import { ExportCSVButton } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/-features/export-csv-button';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { fetchCampaign } from '@/services/campaign';
export const Route = createFileRoute('/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/smart-links-by-destination/')({
    component: SmartLinksByDestinationABPage,
});
function SmartLinksByDestinationABPage() {
    const { publicId } = Route.useParams();
    const { from, to, excludeDevices, excludeBrowsers } = Route.useSearch();
    const { workspace } = useAuthenticationState();
    const [fromDate, toDate] = React.useMemo(() => [new Date(from), new Date(to)], [from, to]);
    const { data: campaign, isPending, isError, } = useQuery({
        queryKey: ['campaign', publicId],
        queryFn: () => fetchCampaign(publicId),
    });
    if (!workspace)
        return null;
    if (isPending)
        return <p className="text-sm text-muted-foreground">Loading…</p>;
    if (isError || !campaign)
        return <p className="text-sm text-destructive">Could not load campaign.</p>;
    const trackingLinks = campaign.trackingLinks ?? [];
    if (trackingLinks.length === 0) {
        return (<p className="text-sm text-muted-foreground">
                No destinations on this campaign yet — add tracking links to compare smart links by destination.
            </p>);
    }
    return (<div className="space-y-4">
            {trackingLinks.map((tl) => (<SmartLinksForTrackingLink key={tl.publicId} trackingLink={tl} workspace={workspace} from={fromDate} to={toDate} excludeDevices={excludeDevices} excludeBrowsers={excludeBrowsers}/>))}
        </div>);
}
const SmartLinksForTrackingLink = ({ trackingLink, workspace, from, to, excludeDevices, excludeBrowsers, }) => {
    const q = useQuery({
        queryKey: [
            'ab',
            'smart-links',
            'destination',
            trackingLink.publicId,
            from,
            to,
            excludeDevices,
            excludeBrowsers,
        ],
        queryFn: () => fetchTrackingEntryPoints({
            publicId: trackingLink.publicId,
            from,
            to,
            excludeDevices,
            excludeBrowsers,
        }),
    });
    return (<ABComparisonView title={`Destination: ${trackingLink.label}`} description="Compare Smart Links under this Destination." heroLabel={`Scans for ${trackingLink.label}`} comparison={q.data} loading={q.isPending} error={q.isError} itemName="Smart Link" actions={<ExportCSVButton filename={`adora-ab-smart-links-destination-${trackingLink.publicId}.csv`} workspace={workspace} request={() => exportTrackingLinkEntryPoints({
                publicId: trackingLink.publicId,
                from,
                to,
                excludeDevices,
                excludeBrowsers,
                fileFormat: 'csv',
            })}/>}/>);
};
SmartLinksForTrackingLink.displayName = 'SmartLinksForTrackingLink';
